import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import AttributeForm from "./FormConfigQualifierAttributeForm";
import { Button, Row, Col } from "antd";
import FormConfigQualifierAttribute, {
  IFormConfigQualifierAttribute
} from "../../../service/formconfiguration/FormConfigQualifierAttribute";

export interface State {}

export interface UpdateFormConfigQualifierAttributeFormProps
  extends FormComponentProps {
  translate: any;
  registerFormSubmitEventHandler?: any;
  formConfigQualifierAttribute: IFormConfigQualifierAttribute;
  updateFormConfigQualifierAttribute(
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ): any;
  Actions: any;
  readOnly: boolean;
}

class UpdateFormConfigQualifierAttributeForm extends React.Component<
  UpdateFormConfigQualifierAttributeFormProps,
  State
> {
  private handleOnChangeEvent = (e) => {
    const {
      formConfigQualifierAttribute,
      updateFormConfigQualifierAttribute
    } = this.props;
    let updatedFormConfigQualifierAttribute = formConfigQualifierAttribute;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        updatedFormConfigQualifierAttribute.attribute = {
          ...formConfigQualifierAttribute.attribute,
          ...values
        };

        updatedFormConfigQualifierAttribute = {
          ...updatedFormConfigQualifierAttribute,
          ...values
        };
        updateFormConfigQualifierAttribute(
          FormConfigQualifierAttribute({
            ...updatedFormConfigQualifierAttribute
          })
        );
      }
    });
  };

  render() {
    const {
      translate,
      formConfigQualifierAttribute,
      Actions,
      readOnly
    } = this.props;

    const { getFieldDecorator, setFieldsValue } = this.props.form;

    return (
      <React.Fragment>
        {!readOnly && (
          <Row gutter={1} type="flex" justify="end">
            <Col>{Actions}</Col>
            <Col>
              <Button type="primary" onClick={this.handleOnChangeEvent}>
                {translate("qualifier_form.apply_changes")}
              </Button>
            </Col>
          </Row>
        )}
        <AttributeForm
          readOnly={readOnly}
          getFieldDecorator={getFieldDecorator}
          translate={translate}
          formConfigQualifierAttribute={formConfigQualifierAttribute}
          setFieldsValue={setFieldsValue}
        ></AttributeForm>
      </React.Fragment>
    );
  }
}

export default UpdateFormConfigQualifierAttributeForm;
